import React from 'react'

/**
 * Tag — tiny emphasis label (e.g. internal-comment marker). Optionally
 * carries a leading icon node.
 */
export function Tag({ tone = 'internal', icon, children, className = '' }) {
  const cls = ['tag', `tag-${tone}`, className].filter(Boolean).join(' ')
  return (
    <span className={cls}>
      {icon}
      {children}
    </span>
  )
}
